// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"e676de00","365":"6bfbcbfa","565":"269fea89","724":"be15a9d9","828":"6375a322","858":"3b24498c","872":"6f8cb5f8","959":"70ec50ca","980":"6927a038"}[chunkId] + ".css";
};